<template>
	<div class="container position-relative width-screen height-all">
        <img class="loginBg" src="../../static/images/icon_login_bg.png" alt="">
        <div class="loginCover">
            <div class="loginInfoDiv position-absolute">
                <img class="loginInfoBg" src="https://www.meiyintutu.com/open/images/os/index/icon_loginBg.png" alt="">

                <div  class="loginLogoinfo position-absolute">
                    <img class="loginLogo position-absolute" src="../../static/images/icon_loginLogo.png" alt="">
                </div>
                <div class="logininfo position-absolute">

                    <div class="loginTypeChange">
                        <!-- 账号登录标签，默认激活 -->
                        <div class="tab" :class="loginType == 'password' ? 'active' : '' " @click="changeLoginType">账号登录</div>
                        <!-- 扫码登录标签 -->
                        <div class="tab" :class="loginType == 'scanCode' ? 'active' : '' " @click="changeLoginType">扫码登录</div>
                    </div>
                    <div v-if="loginType == 'password'" class="loginTelPhone flex align-center">
                        <img src="../../static/images/icon_telphone.png" alt="" class="icon_telphone">
                        <el-autocomplete
                            v-model="telPhoneInput"
                            :fetch-suggestions="queryAccountList"
                            placeholder="请输入账号"
                            class="loginInfoInput height-all"
                            :trigger-on-focus="true"
                            value-key="value"
                        ></el-autocomplete>
                    </div>
                    <div v-if="loginType == 'password'" class="loginPassword flex align-center">
                        <img src="../../static/images/icon_login_pasword.png" alt="" class="icon_code">
                        <el-input type="password" v-model="passwordInput" placeholder="请输入密码"
                                  @keyup.enter.native="login" class="loginInfoInput height-all"></el-input>
                    </div>
                    <el-button v-if="loginType == 'password'" class="loginBtn" @click="login" :loading="loginBtnLoading" >登录</el-button>

                    <!-- 扫码登录 -->
                    <div v-if="loginType == 'scanCode'" class="scanCode">
                        <img :src="isScan ? require('../../static/images/icon_login_isScan2.png') : scanCodeImg" alt="">
                        <div v-if="pollCount == qrCodeTime" class="scanCodeTimeOut">
                            <p>二维码已失效</p>
                            <button class="refreshErcodeBtn" @click="queryRouteParentByTypeAndName()">请点击刷新</button>
                        </div>
                    </div>
                    <div v-if="loginType == 'scanCode' && !isScan" class="scanCodeTip">
                        <img src="../../static/images/icon_login_scanTip2.png" alt="">
                        <div class="scanCodeTipText">
                            <span>打开<span>美印兔兔APP</span></span>
                            <span>扫一扫登录</span>
                        </div>
                    </div>
                    <div v-if="loginType == 'scanCode' && isScan" class="isScanTip flex flex-column">
                        <span>请在手机上确认登录</span>
                        <span @click="queryRouteParentByTypeAndName()">返回二维码登录></span>
                    </div>

                    <div class="Copyright position-absolute">
                        Copyright © {{year}} Hebei MeiyintuTu Network Technology Co., Ltd.  <br/> <br/> 河北美印兔兔网络科技有限公司 版权所有
                    </div>

                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import commonVerify from '@/components/commonVerify'
	import JSEncrypt from '@/utils/jsencrypt.js'
    import md5 from 'js-md5';
     import utils from "../../utils/utils";
    import api from "../../api/api";
	export default {
		inject: ['$http', '$api', '$utils','$userUtils', '$local'],
		name: "login",
		components:{
			commonVerify,
		},
		data() {
			return {
                loginType: 'password',
                isScan: false, //当前二维码是否已经被扫了
                scanCodeImg: '', //登录码
                pollCount: 0, //检测登录的二维码是否失效
                qrCodeTime: 60, //二维码有效期
                pollKey: '', //二维码定时器
                loginPolling: '', //检测用户登录定时器
				errCode: "",  //授权失败返回的code码【0：失败】
				sId: "",  //抖音服务市场授权后获取的sId
				activeName: "telphone", //默认选中的登录方式【telphone：手机号登录    wechat：微信扫码】
				telPhoneInput: "", //手机号
                passwordInput: "",//密码
				vCodeInput: "", //验证码
				checked: false, //是否自动登录【true：是    false：不是】
				icCanClickGetVCode: true,  //区分获取验证码按钮是否可点击
				areaCode: "86",  //区号
				getVCodeBtnTxt: "获取验证码",  //获取验证码按钮文案
				isShowVerifyDialog: false, //是否展示滑动验证dialog
				loginBtnLoading:false,//是否正在请求登录
                year : '',
                accountHistoryList: [], //历史账号列表
			}
		},
		mounted() {
			// 初始化页面
			// this.initPage()
            // 存储UUID和设备信息
            this.$userUtils.getDeviceMessage();
            if(window.UserTokenJs){
                window.UserTokenJs.setPublicKey(this.$api.pubk);
            }
            var data = new Date();
            this.year = Number(data.getFullYear());
            // 从缓存加载历史账号
            this.loadAccountHistory();

		},
		methods: {
            /**
             * 从缓存加载历史账号
             */
            loadAccountHistory() {
                let list = this.$utils.getLocal('LOGIN_ACCOUNT_HISTORY');
                this.accountHistoryList = Array.isArray(list) ? list : [];
            },
            /**
             * 保存账号到缓存（去重）
             */
            saveAccountToCache(account) {
                if (!account) return;
                let list = this.accountHistoryList.filter(item => item !== account);
                list.unshift(account);
                this.accountHistoryList = list;
                this.$utils.setLocal('LOGIN_ACCOUNT_HISTORY', list);
            },
            /**
             * el-autocomplete 查询建议
             */
            queryAccountList(queryString, cb) {
                let results = this.accountHistoryList.map(item => ({ value: item }));
                if (queryString) {
                    results = results.filter(item => item.value.indexOf(queryString) !== -1);
                }
                cb(results);
            },
			/**
			 * 初始化页面
			 */
			initPage () {
				/* 获取抖音授权后进入登录页,传递的errCode */
				if (this.$route.query.errCode) {
					this.errCode = this.$route.query.errCode;
					this.$message.error("授权失败，请到抖店-服务市场重新打开服务");
					return;
				} else {
					/* 获取抖音授权后进入登录页,传递的sId */
					console.log("地址中携带sId:::" + this.$route.query.sId);
					if (!this.$utils.isEmpty(this.$route.query.sId)) {
						this.sId = this.$route.query.sId;

						//将sId存储到缓存中，便于扫码登录在order.html中使用
						this.$utils.setLocal("sId", this.sId);
						//获取 cip
						this.$utils.setLocal('cip', returnCitySN["cip"]);
						console.log("cip:" + this.$utils.getLocal("cip"));
						// loginVue.autoLogin();
					}

					/* 获取微信登录二维码 */
					//loginVue.getWechatQrcodeImg();

				}
			},
			/**
			 * 获取验证码按钮点击事件
			 */
			getVCodeClick() {
				let that = this;
				//验证手机号是否为空
				if (this.$utils.isEmpty(that.telPhoneInput)) {
					that.$message("请输入手机号");
				} else {
					// 如果是线上环境，走滑动图片验证
					if(this.$api.itemEnv == 1){
						if (that.icCanClickGetVCode) {
							//显示滑块验证
							that.isShowVerifyDialog = true;
						}
					}else{
						this.getVCodeByMove()
					}

				}
			},
			/**
			 * 滑动获取短信验证码
			 */
			getVCodeByMove() {
				let that = this;
				this.$http.post(this.$api.getPhoneCodeApi, {
					"sign": '13', // 1 绑定手机号； 3 重置密码； 4 注册； 5 解绑； 7 图形验证； 8 佣金体现； 13 滑块验证； 17 钱包支付；
					"phone": that.telPhoneInput,
					"encodeData": this.$utils.rsa(that.telPhoneInput,this.$api.pubk),
					"areaCode": that.areaCode,
				}).then(res=>{
					if (res.code == 200) {
						that.icCanClickGetVCode = false;
						let lastTimeNum = 60,
							timer = setInterval(function () {
								lastTimeNum--;
								that.getVCodeBtnTxt = "(" + lastTimeNum + "s)后重新获取";
								if (lastTimeNum == 0) {
									clearInterval(timer);
									that.getVCodeBtnTxt = "获取验证码";
									that.icCanClickGetVCode = true;
								}
							}, 1000);
					} else {
						that.$message.error(res.msg || res.message);
					}
					that.isShowVerifyDialog = false;
				})
			},
			/**
			 * 关闭滑动验证弹层
			 */
			closeVerifyCover(data) {
				this.isShowVerifyDialog = data;
			},
			/**
			 * 登录按钮点击事件
			 */
			login() {
				let that = this;
				that.sId = this.$utils.getLocal("sId");
				console.log("sId:::" + that.sId);
				if (this.$utils.isEmpty(that.telPhoneInput)) {
					return that.$message({
						message: '请输入用户名',
						customClass: 'messageClass',
					});
				} else if (this.$utils.isEmpty(that.passwordInput)) {
					return that.$message({
						message: '请输入密码',
						customClass: 'messageClass',
					});
				} else {
					this.loginBtnLoading = true;
					this.$http.post(this.$api.loginApi, {
                        "userName": this.$utils.rsa(that.telPhoneInput,api.pubk) ,
                        "pwd": this.$utils.rsa(that.passwordInput,api.pubk)
					}).then(res=>{
						this.loginBtnLoading = false;
						if (res.code == 200) {
                            this.loginBtnLoading = true;
                            //将token存储到本地缓存中
                            this.$userUtils.setUserToken(res.data.token,(res.data.expire))

                            if(window.UserTokenJs){
                                window.UserTokenJs.setUserToken(res.data.token)
                            }
                            // this.$utils.setLocal("MY_Admin-TokenInfo", JSON.stringify(res.data));
                            this.$message.success("登录成功");
                            this.saveAccountToCache(that.telPhoneInput);
                            this.getPurview()
                        }else{
                            that.$message.error(res.msg || res.message);
                        }
					}).catch(err => {
                        this.loginBtnLoading = false;
                      })
				}
			},
			/**
			 * 检测token是否过期
			 */
			autoLogin() {
				let that = this;
				let sId = this.$utils.getLocal("sId");
				let token = this.$userUtils.getUserToken();
				this.$loading();
				this.$http.post(autoLoginApi, {
					"sId": sId,
				}, function (res) {
					this.$loading.close();
					if (res.code == 200) {
						this.$utils.setLocal("shopId", res.data.shopId);
						if (this.$utils.isEmpty(token)) {
							return;
						} else {
							$.openPage("home.html?actionIndex=0");
						}
					}
				})
			},
			/**
			 * 获取权限信息
			 */
			getPurview(){
				this.$http.post(this.$api.getUserInfoApi).then(res=>{
					if(res.code == 200){
                        this.$userUtils.setUserInfo(res.data)
                        //将token存储到本地缓存中
                        this.$local.setToken(res.data.token);
                        this.$local.setTokenInfo(JSON.stringify(res.data));
                        if(window.JFXWindow){
                            window.JFXWindow.toHome();
                        }else {
                            this.$router.push('/home')
                        }
                    }else {
                        this.$message.error(res.msg || res.message);
                    }
				})
			},
            /**
             * 切换登录方式
             */
            changeLoginType() {
                this.loginType = this.loginType == 'password' ? 'scanCode' : 'password';
                if (this.loginType == 'scanCode') {
                    this.queryRouteParentByTypeAndName()
                } else {
                    clearInterval(this.pollKey);
                    clearInterval(this.loginPolling);
                }
            },
            /**
             * 获取扫描的二维码
             */
            queryRouteParentByTypeAndName() {
                clearInterval(this.pollKey);
                clearInterval(this.loginPolling);
                this.isScan = false;
                let uid = this.$utils.getRandom() + '' + this.$utils.generateRandomString(3);
                this.$http.postArray(this.$api.genLoginQRCodeApi + '?scanReqId=' + uid).then(res => {
                    this.scanCodeImg = window.URL.createObjectURL(new Blob([res], {
                        type: 'image/png'
                    }));
                    this.pollCount = 0;
                    // 获取生成的unionId是否有人扫码
                    this.pollingFun(uid);
                })
            },
            /**
             * 获取生成的unionId是否有人扫码
             */
            pollingFun(uid) {
                this.$http.post(this.$api.checkLoginQRCodeStatusApi, {
                    scanReqId: uid
                }).then(res => {
                    if (res.code == 200) {
                        if (res.data == 1) {
                            //返回值 说明已经扫码了
                            this.isScan = true;
                            this.pollingSubmitLogin(uid);
                        } else if (res.data == 0) {
                            // 继续检测当前二维码是否被扫描
                            this.pollKey = setTimeout(() => {
                                this.pollingFun(uid)
                            }, 1000)
                        } else {
                            // 二维码已失效
                            this.pollCount = 60;
                        }
                    }
                })
            },
            /**
             * 检测用户是否登录了
             */
            pollingSubmitLogin(uid) {
                this.$http.post(this.$api.getOauthCodeApi, {
                    scanReqId: uid
                }).then(res => {
                    if (res.code == 200) {
                        if (res.data) {
                            this.$http.post(this.$api.loginByOauthCodeApi, {
                                scanReqId:uid,
                                code: res.data
                            }).then(loginRes => {
                                if (loginRes.code == 200) {
                                    console.log(loginRes.data.expire)
                                    // this.$userUtils.setUserToken(loginRes.data.token, this.$utils.getTimeStamp() + Number(loginRes.data.expireMillis))
                                    // 获取用户权限
                                    // this.getSysUserLoginInfo();
                                    this.$userUtils.setUserToken(loginRes.data.token,(loginRes.data.expire))

                                    if(window.UserTokenJs){
                                        window.UserTokenJs.setUserToken(loginRes.data.token)
                                    }
                                    // this.$utils.setLocal("MY_Admin-TokenInfo", JSON.stringify(res.data));
                                    this.$message.success("登录成功");
                                    this.getPurview()
                                }
                            })
                        } else {
                            this.loginPolling = setTimeout(() => {
                                this.pollingSubmitLogin(uid)
                            }, 1000)
                        }
                    }
                })
            },


		},
	}
</script>

<style scoped>

    .container{
        background-color: rgba(241, 245, 254, 1);
    }
    .loginBg{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .loginCover{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
    }
	.loginInfoDiv{
        width: 92%;
        /* max-width: 1180px; */
        min-width: 1016px;
        display: flex;
        align-items: stretch;
        position: relative;
	}
    .loginInfoBg{
        width: 100%;
        height: 100%;
    }
    .loginLogoinfo{
        width: 50.5%;
        height: 80.2%;
        top: 10%;
        left: 5%;
    }
    .loginLogo{
        width: 115px;
        top: 5%;
        left: 9.2%;
    }
    .logininfo{
        width: 39.2%;
        height: 57.2%;
        top: 10%;
        right: 5%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 7.5% 0 6% 0;
    }
    .loginTypeChange{
        width: 59%;
        display: flex;
        border-bottom: 2px solid #F6F6F6;
        margin-bottom: 20px;
    }
    .tab {
        padding: 10px 0px;
        cursor: pointer;
        font-size: 14px;
        color: #131415;
        margin-right: 56px;
        position: relative;
        bottom: -2px;
    }
    .tab.active {
        border-bottom: 2px solid #3b82f6;

    }

    .loginPassword,
    .loginTelPhone{
        width: 59%;
        height: 41px;
        padding: 0 8px;
        box-sizing: border-box;
        margin-bottom: 20px;
        background: #FBFCFF;
        border-radius: 6px;
        border: 2px solid #D3D4D6;
    }
    .icon_telphone,
    .icon_code {
        width: 14px;
        margin-right: 4px;
    }

    .loginBtn{
        width: 59%;
        background-color: #1A65FF !important;
        color: #fff !important;
        border: none !important;
        border-radius: 0 !important;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px!important;
        margin-top: 20px;
    }

    /* 扫码登录 */
    .scanCode {
        border-radius: 20px;
        border: 1px solid #D7D7D7;
        padding: 10px 10px 8px 10px;
        width: 38%;
        /* height: 200px; */
        box-sizing: border-box;
        position: relative;
         /*overflow: hidden;*/
    }

    .scanCode img {
        width: 100%;
    }

    .scanCodeTip {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 23px;
        font-size: 12px;
        color: #000000;
    }

    .scanCodeTip span span {
        color: #4980F8;
    }

    .scanCodeTip img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
    }

    .scanCodeTipText {
        display: flex;
        flex-direction: column;
    }

    .scanCodeTimeOut {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.78);
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        flex-wrap: wrap;
        border-radius: 20px;
    }

    .scanCodeTimeOut button {
        width: 120px;
        height: 40px;
        border: 0;
        border-radius: 30px;
        color: #fff;
        font-size: 14px;
        /*background: linear-gradient(180deg, #ff4fa6 0%, #FF4F81 100%);*/
        /*background: -webkit-linear-gradient(180deg, #ff4fa6 0%, #FF4F81 100%);*/
        background: #1A65FF;
        /*box-shadow: 0px 4px 8px 2px rgba(255, 79, 131, 0.43);*/
    }
    .scanCodeTimeOut p{
        font-size: 14px;
        margin-bottom: 8px;
    }
    .Copyright{
        bottom: 9%;
        width: 96%;
        left: 2%;
        text-align: center;
        font-size: 12px;
        color: #999999;
        transform: scale(0.8);
        transform-origin:  center; /* 确保缩放从左侧开始，避免布局错乱 */
        display: inline-block; /* 配合 transform-origin 使用 */
    }
    .isScanTip {
        height: 100%;
        justify-content: space-around;
        text-align: center;
        font-size: 12px;
        color: #000000;
        padding: 24px;
    }

    .isScanTip span:last-child {
        color: #4980F8;
        cursor: pointer;
    }


</style>
<style>
	.loginInfoInput .el-input__wrapper{
		background: #FBFCFF !important;
		box-shadow: none !important;
		padding: 0 !important;
	}
    .loginInfoInput .el-input__inner{
        background: #FBFCFF !important;
        box-shadow: none !important;
        padding: 0 !important;
    }
</style>
